import { render } from "./categoriesBlock.vue?vue&type=template&id=099b52c2&scoped=true&ts=true"
import script from "./categoriesBlock.vue?vue&type=script&lang=ts"
export * from "./categoriesBlock.vue?vue&type=script&lang=ts"

import "./categoriesBlock.vue?vue&type=style&index=0&id=099b52c2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099b52c2"]])

export default __exports__